module.exports = __webpack_public_path__ + "static/media/bg.67a9d9dc.png";